import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const EditFormatPage = () => (
  <TitleEntityForm
    load={apiRequests.events.getFormat}
    update={apiRequests.events.updateFormat}
    backTo="/events/formats"
    savedText="Формат сохранён"
  />
);

export default EditFormatPage;
